import * as React from 'react';
import {RouteComponentProps} from "react-router";
import {Policy, productHelper, Subscription, Types, ICustomerPortalService, ProductsEnum, FalconNavigatorHeader, POLICY_STATUS_MTC} from "@falcon/services";
import {authorize, Overlay} from "@athena-portal/components";
import {PluginTemplates} from "../../../../../utils/PluginTemplates";
import {lazyInject} from "@athena-portal/core";
import {YourRentersCoverPanel} from "./YourRentersCoverPanel";
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import FalconFooter from "../../../../../components/navigation/FalconFooter";
import { ValuablesSuccessModal } from "../../../../../components/modals/ValuablesSuccessModal";

interface IProps extends RouteComponentProps<{}> {}

interface IState {
    policies?: Policy[];
    subscription?: Subscription;
}

@authorize
export class YourRentersCoversPage extends React.Component<IProps, IState> {

    private pluginTemplates = new PluginTemplates();

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: IProps) {
        super(props);

        this.state = {};
    }

    public componentDidMount(): void {
        this.pluginTemplates.setPageTitle("Your renters covers");

        this.customerPortalService.getPolicies(ProductsEnum.RENTERS).subscribe(
            (policies: Policy[]) => {
                this.setState({
                    policies
                });
            }
        );

        this.customerPortalService.getSubscription().subscribe((subscription: Subscription) => {
            this.setState({
                subscription
            });
        });
    }

    public render() {
        const {policies, subscription} = this.state;
        const dataLoaded = policies && subscription;
        return (
            <React.Fragment>
                <Overlay show={!dataLoaded}/>
                <FalconHeader/>
                <div className="page-contents">
                    <FalconNavigatorHeader back="/dashboard/monthlySubscription" title="Your Renters cover"/>
                    {dataLoaded && this.renderHeadsUpPanel()}
                    {dataLoaded && this.renderYourRentersCoverPanels()}
                    {this.pluginTemplates.renderBackLink("Back", false, "/dashboard/monthlySubscription")}
                </div>
                <FalconFooter/>
                <ValuablesSuccessModal policies={this.state.policies}/>
            </React.Fragment>
        );
    }

    private renderHeadsUpPanel(): JSX.Element {
        let cancelled: boolean = false;
        if (this.state.policies) {
            cancelled = this.state.policies.every(p => p.status === POLICY_STATUS_MTC);
        }
        return cancelled ?
            <div className="_panel banner banner-info">
                Heads up - due to <b>cancellation</b>, adding / editing your items is not available.
            </div> : <></>;
    }

    private renderYourRentersCoverPanels(): JSX.Element[] | void {
        const {policies, subscription} = this.state;
        return policies!.filter((policy: Policy) => productHelper.isRenters(policy.interaction)).map(
            (policy: Policy, index: number) => (
                <YourRentersCoverPanel
                    {...this.props}
                    key={index}
                    policy={policy}
                    subscription={subscription!}
                    policyIndex={index}
                />
            )
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/subscription/renters/yourRentersCoverPage/YourRentersCoversPage.tsx